import FadeIn from "./FadeIn";

export default FadeIn;
export { FadeIn };



// WEBPACK FOOTER //
// ./src/index.js